import { DateTime } from 'luxon';
import cloneDateTime from './cloneDateTime';
import isAfterDay from './isAfterDay';
import isBeforeDay from './isBeforeDay';
import toISOMonthString from './toISOMonthString';

const startCacheOutsideDays = new Map();
const endCacheOutsideDays = new Map();

const startCacheInsideDays = new Map();
const endCacheInsideDays = new Map();

export default function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
    if (!(day instanceof DateTime)) return false;

    const startKey = toISOMonthString(month);
    const endKey = `${startKey}+${numberOfMonths}`;

    if (enableOutsideDays) {
        if (!startCacheOutsideDays.has(startKey)) {
            startCacheOutsideDays.set(
                startKey,
                cloneDateTime(month).startOf('month').startOf('week').set({ hours: 12 })
            );
        }

        if (isBeforeDay(day, startCacheOutsideDays.get(startKey))) return false;

        if (!endCacheOutsideDays.has(endKey)) {
            endCacheOutsideDays.set(
                endKey,
                cloneDateTime(month)
                    .endOf('week')
                    .plus({ months: numberOfMonths - 1 })
                    .endOf('month')
                    .endOf('week')
                    .set({ hours: 12 })
            );
        }

        return !isAfterDay(day, endCacheOutsideDays.get(endKey));
    }

    // !enableOutsideDays

    if (!startCacheInsideDays.has(startKey)) {
        startCacheInsideDays.set(startKey, cloneDateTime(month).startOf('month').set({ hours: 12 }));
    }

    if (isBeforeDay(day, startCacheInsideDays.get(startKey))) return false;

    if (!endCacheInsideDays.has(endKey)) {
        endCacheInsideDays.set(
            endKey,
            cloneDateTime(month)
                .plus({ months: numberOfMonths - 1 })
                .endOf('month')
                .set({ hours: 12 })
        );
    }

    return !isAfterDay(day, endCacheInsideDays.get(endKey));
}
